/* Hero Scroll-Scrub (A案) — poster 先行。動画は初回描画後に 1 本だけ取得して再生する。 */
(() => {
  const init = (hero) => {
    if (hero.dataset.jheroReady) return;
    hero.dataset.jheroReady = '1';

    const video = hero.querySelector('.jhero__video');
    if (!video) return;

    const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (conn && conn.saveData) return;

    const pickSrc = () => {
      const d = video.dataset;
      if (d.srcWebm && video.canPlayType('video/webm')) return d.srcWebm;
      const small = matchMedia('(max-width: 880px)').matches;
      return (small ? d.srcSm : d.srcLg) || d.srcSm || d.srcLg || '';
    };

    let started = false;
    let inView = false;

    const play = () => {
      const p = video.play();
      if (p && p.catch) p.catch(() => {});
    };

    const start = () => {
      const src = pickSrc();
      if (!src) return;
      started = true;
      video.muted = true;
      video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
      video.src = src;
      play();
    };

    const onView = (visible) => {
      inView = visible;
      if (!visible) {
        if (started) video.pause();
        return;
      }
      if (started) play();
      else start();
    };

    const arm = () => {
      if (!('IntersectionObserver' in window)) {
        onView(true);
        return;
      }
      new IntersectionObserver((entries) => {
        onView(entries[entries.length - 1].isIntersecting);
      }).observe(hero);
    };

    const whenIdle = () => {
      if ('requestIdleCallback' in window) requestIdleCallback(arm, { timeout: 2000 });
      else setTimeout(arm, 200);
    };

    if (document.readyState === 'complete') whenIdle();
    else addEventListener('load', whenIdle, { once: true });

    addEventListener('pageshow', (e) => {
      if (e.persisted && started && inView) play();
    });
  };

  document.querySelectorAll('.jhero--scrub').forEach(init);
})();
